export default {
  escala_item: {},
  escalas_itens: [],
};
